import DirectoryTree from '@/views/Config/Templates/DirectoryTree.vue'

export default {
  components: {
    DirectoryTree
  },
  data () {
    return {

    }
  },
  methods: {
    upTree () {
      console.log(1)
    },
    handleClick () {
      console.log(1)
    },
    exportedBtn () {

    },
    importsBtn (val) {
      // console.log('导入')
    }
  }
}
